export default __webpack_public_path__ + "static/media/26_strings_dark_blue.cbd1cbd8.png";